import { useState, useEffect, useRef } from 'react';
import Style from "./css/style.module.css";
import getXcolumnJson from "./xcolumn/list";
import DateFunc from '@/lib/lyg/date_func';
import strFunc from '@/lib/lyg/string';
import LayerPopup from '@/pcomponents/common/popup/layer/layer_popup';
import ViewTodoDaySortPopup from "@/pages/comp/plan/calendar/area/popup/view_todo_day_sort";
import SendSMSPopup from "@/pages/comp/basic/sms/popup/send_sms";
import AddAttendPopup from "@/pages/comp/edu/attend/popup/add_attend";
import WriteTodoPopup from "@/pages/comp/plan/todo/popup/write";
import ViewStuLayerPopup from "@/pages/comp/basic/student/popup/view_layer";
import WriteTodoDailyCByStuPopup from "@/pages/comp/plan/todo_dailyc/popup/write_by_stu";
import TabArea from '@/pcomponents/common/content/list/user/search/tab_area';
import TopSearchDayArea from "./area/search_day";
import TopSearchSort from "./area/top_search_sort";
import TopSearchStateArea from "./area/top_search_state";
import SearchArea from "@/pages/comp/basic/student/list/area/search/search_area";
import CardListArea from "./area/card_list";
import Paging from "@/pcomponents/common/crud/list/paging/paging";
import RadioListArea from "@/pcomponents/common/crud/write/radio/radio_arr";
import WritePage from "@/pages/comp/basic/student/common/write";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import PageFunc from "./func/page_func";
import LoadingComponent from "@/pcomponents/common/content/loading";
import DataIo from "./area/io";

function TodoStuCardListArea() {
  const navigate = useNavigate();
  let user = useSelector((state: any) => state.user);
  const [tab_id, set_tab_id] = useState("lecture");
  const [infoArr, setInfoArr] = useState([]);
  const infoArrRef = useRef<any>([]);
  infoArrRef.current = infoArr;
  const [countInfo, setCountInfo] = useState({ "tot": 0 });
  const xColumnArr = getXcolumnJson();
  const [check_row_val_arr, set_check_row_val_arr] = useState([]);//["stu_seq,subject_name",...]
  const [sms_phone_check, set_sms_phone_check] = useState("student");//student,parent,both
  const [select_idx, set_select_idx] = useState(0);
  const [is_detail_view, set_is_detail_view] = useState(false);
  const [is_only_now_desk, set_is_only_now_desk] = useState(false);
  const data_io_ref = useRef<any>(null);
  const [now_ymdhis, set_now_ymdhis] = useState(DateFunc.get_date_format(new Date(), "Y-m-d h:i:s"));
  const [is_now_time, set_is_now_time] = useState(true);
  const now_ymdhis_ref = useRef(now_ymdhis);
  const [loading_data, set_loading_data] = useState({
    is_display: false,
    text: "저장 되었습니다.",
  });

  let now_ymd_str = DateFunc.get_date_format(new Date(), "Y-m-d");
  const [listOpt, setListOpt] = useState({
    ...xColumnArr.list_opt,
    s_is_login: "1",
    s_stu_state: "now",
    s_grade: ["student"],
    //s_addon_class_user: "1",
    //s_addon_link_user: "1",
    s_user_name_like: "",
    s_school_name_like: "",
    s_class_name_like: "",
    s_stu_grade: "",
    s_addon_todo: "1",
    s_addon_todo_start_date: now_ymd_str,
    s_addon_todo_end_date: now_ymd_str,
    s_addon_todo_s_todo_sort: "",
    s_addon_todo_elapse_time: "1",
    s_addon_todo_s_state: "",
    s_addon_todo_addon_par: "",
    s_addon_todo_addon_file: "1",
    s_addon_home_work_file: "1",
    s_addon_home_work_file_start_date: now_ymd_str,
    s_addon_home_work_file_end_date: now_ymd_str,
    s_addon_plan_study_file: "1",
    s_addon_plan_study_file_start_date: now_ymd_str,
    s_addon_plan_study_file_end_date: now_ymd_str,
    s_addon_attend: "1",
    s_addon_attend_start_date: now_ymd_str,
    s_addon_attend_end_date: now_ymd_str,
    s_attend_sort_detail: "",
    s_attend_start_date: now_ymd_str,
    s_attend_end_date: now_ymd_str,
    s_stu_lecture_seq:"",// user.user_grade == "master" ? "" : strFunc.get_storage_array("s_stu_lecture_seq", "", ",")
    s_addon_lecture_time: "1",
    s_addon_todo_dailyc: "1",
    s_addon_todo_dailyc_start_date: now_ymd_str,
    s_addon_todo_dailyc_end_date: now_ymd_str,
    s_addon_daily_report_last: "1",
    s_addon_daily_report_last_addon_study_use: "",
    s_addon_study_det_by_daily_last: "1",
    s_addon_daily_report: "1",
    s_addon_daily_report_start_date: now_ymd_str,
    s_addon_daily_report_end_date: now_ymd_str,
    s_addon_daily_report_addon_study_use: "",
    s_addon_desk_use: "1",
    s_addon_desk_use_start_date: now_ymd_str,
    s_addon_desk_use_end_date: now_ymd_str,
    s_addon_now_time: "1",
  });
  const listOptRef = useRef<any>(listOpt);
  listOptRef.current = listOpt;
  listOptRef.current.s_select_date = listOpt.s_addon_todo_start_date;

  useEffect(() => {
    const count_loop = setInterval(tick_now_ymdhis, 1000);
    return () => {
      clearInterval(count_loop);
    };
  }, [infoArr]);

  const [popupData, setPopupData] = useState<any>({
    isOpen: false,
    sort: "todo_day_sort",//todo_day_sort, send_sms, add_attend
    rowData: {},
    isUpdate: false,
    select_stu_name: "",
    select_stu_seq: "",
    select_date: "",
    subject_name: "",
    receive_arr: [],
    attend_sort: "in",//in,out
    attend_sort_detail: "",
    user_info_arr: [],
    todo_info: {},
    todo_sort: "study",
    todo_dailyc_sort: "complete",
    has_header: true,
    write_page_data: {
      is_show: false,
      is_update: false,
      is_view_mode: true,
      is_view_basic: false,
      info_arr: [],
      select_idx: 0,
      default_write_info: {},
    },
    title: "맞춤플랜 보기",
    width: "500px",
    height: "100%",
  });
  
  PageFunc.data = {
    user: user,
    infoArr: infoArr,
    setInfoArr: setInfoArr,
    countInfo: countInfo,
    setCountInfo: setCountInfo,
    xColumnArr: xColumnArr,
    check_row_val_arr: check_row_val_arr,
    set_check_row_val_arr: set_check_row_val_arr,
    sms_phone_check: sms_phone_check,
    set_sms_phone_check: set_sms_phone_check,
    select_idx: select_idx,
    set_select_idx: set_select_idx,
    is_detail_view: is_detail_view,
    set_is_detail_view: set_is_detail_view,
    listOpt: listOpt,
    setListOpt: setListOpt,
    popupData: popupData,
    setPopupData: setPopupData,
    tab_id: tab_id,
    set_tab_id: set_tab_id,
    now_ymd_str: now_ymd_str,
    is_only_now_desk: is_only_now_desk,
    loading_data: loading_data,
    set_loading_data: set_loading_data,
    set_now_ymdhis: set_now_ymdhis,
    data_io_ref: data_io_ref,
  };

  useEffect(() => {
    PageFunc.list({});
  }, []);

  const tick_now_ymdhis = () => {
    if (now_ymd_str != DateFunc.get_date_format(new Date(now_ymdhis_ref.current), "Y-m-d")) {
      return false;
    }
    let tick_date_obj = DateFunc.get_change_date(new Date(now_ymdhis_ref.current), 'sec', +1);
    now_ymdhis_ref.current = DateFunc.get_date_format(tick_date_obj, "Y-m-d h:i:s");
    set_now_ymdhis(now_ymdhis_ref.current);
  };

  return (
    <div>
      {is_detail_view == false &&
        <div>
          <TabArea
            tab_id={tab_id}
            set_tab_id={set_tab_id}
          ></TabArea>
          <div style={{ position: "relative" }}>
            <TopSearchDayArea
              listOpt={listOpt}
              list={PageFunc.list}
              select_date={listOpt.s_addon_todo_start_date}
              set_select_date={(inData: any) => {
                PageFunc.list({
                  now_page: 1,
                  s_addon_todo_start_date: inData,
                  s_addon_todo_end_date: inData,
                });
              }}
            ></TopSearchDayArea>
            <TopSearchStateArea
              Style={Style}
              listOpt={listOpt}
              list={PageFunc.list}
            ></TopSearchStateArea>
          </div>

          <div className="mt-5">
            <SearchArea
              listOpt={listOpt}
              setListOpt={setListOpt}
              list={PageFunc.list}
              xColumnArr={xColumnArr}
              search_line_right_text={
                <span>
                  <button className={"btn " + (is_only_now_desk ? "btn-sky" : "btn-gray")}
                    style={{ height: "36px" }}
                    onClick={() => {
                      set_is_only_now_desk(!is_only_now_desk);
                      PageFunc.list({});
                    }}>현재</button>
                </span>
              }
            ></SearchArea>
          </div>
          <div className={Style.plan_cal_middle_wrap + " mt-1"}>
            <TopSearchSort
              listOpt={listOpt}
              list={PageFunc.list}
            ></TopSearchSort>
          </div>
          <div className="mt-1" style={{ position: "relative" }}>
            {check_row_val_arr.length > 0 &&
              <span style={{ position: "absolute", top: 3, left: 0 }}>
                <span style={{ color: "green" }}>{check_row_val_arr.length}</span>개 선택
              </span>
            }
            <div className="text-right">
              <RadioListArea
                valueTextArr={[
                  { "value": "student", "text": "학생" },
                  { "value": "parent", "text": "부모님" },
                  { "value": "both", "text": "둘다" },
                ]}
                value={sms_phone_check}
                name={"sms_phone_check"}
                handleInputChange={(e: any) => {
                  set_sms_phone_check(e.target.value);
                }}
              ></RadioListArea>
              <button className="btn-m btn-gray ml-1" onClick={() => { PageFunc.openSendSmsPopup(); }} >문자전송</button>
              <button className="btn-m btn-sky ml-1" onClick={() => { PageFunc.openTodoDailyCWritePopup({}); }}>완료처리</button>
              <button className="btn-m btn-gray ml-1" onClick={() => { navigate("/comp/plan/todo_dailyc/month_list"); }} >완료이력</button>
              <span style={{ display: "none" }}>
                <button className="btn-m btn-gray ml-1"
                  style={{ background: "#53a500" }}
                  onClick={() => { PageFunc.openAttendBySelect("in", "attend"); }} >등원</button>
                {/* <button className="btn-m btn-gray ml-1" 
              style={{background:"#EABF0B"}}
              onClick={()=>{openAttendBySelect("in","late");}} >지각</button> */}
                <button className="btn-m btn-gray ml-1"
                  style={{ background: "#F26B6F" }}
                  onClick={() => { PageFunc.openAttendBySelect("in", "absent"); }} >결석</button>
                <button className="btn-m btn-gray ml-1"
                  style={{ background: "#7461ff" }}
                  onClick={() => { PageFunc.openAttendBySelect("out", "out"); }} >하원</button>
              </span>
            </div>
          </div>
          <CardListArea
            infoArr={infoArr}
            setInfoArr={setInfoArr}
            tab_id={tab_id}
            Style={Style}
            check_row_val_arr={check_row_val_arr}
            set_check_row_val_arr={set_check_row_val_arr}
            base_date_str={listOpt.s_addon_todo_start_date}
            now_ymdhis={now_ymdhis}
            openTodoDaySort={PageFunc.openTodoDaySort}
            xColumnArr={xColumnArr}
            is_only_now_desk={is_only_now_desk}
            deleteAttend={PageFunc.deleteAttend}
            openAttendPopup={PageFunc.openAttendPopup}
            openTodoWriteOnePopup={PageFunc.openTodoWriteOnePopup}
            show_detail_user_by_seq={(user_seq: any) => {
              for (let i = 0; i < infoArr.length; i++) {
                if (infoArr[i]["a_seq"] == user_seq) {
                  PageFunc.show_detail_view(i);
                }
              }
            }}
            openTodoDailyCWritePopup={PageFunc.openTodoDailyCWritePopup}
            go_todo_dailyc_write={PageFunc.go_todo_dailyc_write}
          ></CardListArea>
          <Paging now_page={listOpt.now_page}
            num_per_page={listOpt.num_per_page}
            total_rec={countInfo.tot}
            onChangePage={(now_page: number) => { PageFunc.list({ now_page: now_page }); }}
            is_view_num_per_page={true}
            onChangeNumPerPage={(num_per_page: number) => { PageFunc.list({ now_page: 1, num_per_page: num_per_page }); }}></Paging>
          {popupData.isOpen &&
            <LayerPopup closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }} title={popupData.title}
              width={popupData.width} height={popupData.height} title_bar_style={{ borderBottom: 0 }}
              content_div_style={{ padding: "10px 0px" }} y={"0"} has_header={popupData.has_header} >
              {popupData.sort == "todo_day_sort" &&
                <ViewTodoDaySortPopup
                  list_opt={{
                    "s_stu_user_name": popupData.select_stu_name,
                    "s_stu_user_seq": popupData.select_stu_seq,
                    "s_start_date": popupData.select_date,
                    "s_end_date": popupData.select_date,
                    "s_subject": popupData.subject_name,
                  }}
                  list={PageFunc.list}
                  openTodoWriteOnePopup={PageFunc.openTodoWriteOnePopup}
                  closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
                ></ViewTodoDaySortPopup>
              }
              {popupData.sort == "send_sms" &&
                <SendSMSPopup
                  receive_arr={popupData.receive_arr}
                  closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
                  callBackRefresh={PageFunc.list}
                ></SendSMSPopup>
              }
              {popupData.sort === "add_attend" &&
                <AddAttendPopup
                  attend_sort={popupData.attend_sort}
                  attend_sort_detail={popupData.attend_sort_detail}
                  attend_date={popupData.select_date}
                  userInfoArr={popupData.user_info_arr}
                  callback={() => { PageFunc.list({}); }}
                  closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}></AddAttendPopup>
              }
              {popupData.sort == "todo_write_one" &&
                <WriteTodoPopup
                  stu_seq={popupData.select_stu_seq}
                  stu_name={popupData.select_stu_name}
                  select_date={popupData.select_date}
                  rowData={popupData.todo_info}
                  todo_sort={popupData.todo_sort}
                  isUpdate={popupData.isUpdate}
                  callback={(inData: any) => {
                    PageFunc.list({});
                  }}
                  closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
                ></WriteTodoPopup>
              }
              {popupData.sort === "stu_view" &&
                <ViewStuLayerPopup
                  write_page_data={popupData.write_page_data}
                  callback={() => { PageFunc.list({}); }}
                  closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
                ></ViewStuLayerPopup>
              }
              {popupData.sort === "todo_dailyc_write" &&
                <WriteTodoDailyCByStuPopup
                  select_date={popupData.select_date}
                  subject_name={popupData.subject_name}
                  stu_seq_arr={popupData.select_stu_seq_arr}
                  sort={popupData.todo_dailyc_sort}
                  callback_refresh={() => { PageFunc.list({}); }}
                  callback_complete={(inData: any) => {
                    if (inData.todo_dailyc_arr) {
                      PageFunc.update_io_of_todoc({
                        todo_dailyc_arr: inData.todo_dailyc_arr,
                      });
                      if (inData.end_desk_use_arr && inData.end_desk_use_arr.length > 0) {
                        PageFunc.update_io_of_desk_use_arr({
                          desk_use_arr: inData.end_desk_use_arr,
                        });
                      }
                    }
                  }}
                  callback_delete_todoc={(inData: any) => {
                    if (inData.todo_dailyc_arr) {
                      PageFunc.update_io_of_todoc({
                        todo_dailyc_arr: inData.todo_dailyc_arr,
                        detail: "delete",
                      });
                    }
                  }}
                  closePopup={() => { setPopupData({ ...popupData, "isOpen": false }); }}
                ></WriteTodoDailyCByStuPopup>
              }
            </LayerPopup>
          }
        </div>
      }
      {is_detail_view &&
        <WritePage
          info_arr={infoArr}
          select_idx={select_idx}
          close_write={PageFunc.close_detail_view}
          list={PageFunc.list}
          is_update={true}
          is_view_stu_info={true}
          is_view_parent={true}
          is_view_supply={true}
        ></WritePage>
      }
      <LoadingComponent is_display={loading_data.is_display} text={loading_data.text}></LoadingComponent>
      <DataIo
        data_io_ref={data_io_ref}
        student_info_arr_ref={infoArrRef}
        set_student_info_arr={setInfoArr}
        listOptRef={listOptRef}
      ></DataIo>
    </div>
  );
}

export default TodoStuCardListArea;